import React from "react";
import { useTranslation } from "react-i18next";
import { socialLinks } from "@/config/socialLinks";

/* ---------- Inline monochrome brand SVGs (currentColor) ---------- */

const IconX = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644Z" />
    </svg>
);

const IconGitHub = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M12 .5C5.73.5.5 5.74.5 12.02c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.56 0-.28-.01-1.02-.02-2-3.2.7-3.87-1.54-3.87-1.54-.52-1.32-1.28-1.67-1.28-1.67-1.05-.72.08-.71.08-.71 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.73-1.55-2.55-.29-5.24-1.28-5.24-5.7 0-1.26.45-2.29 1.19-3.1-.12-.29-.52-1.47.11-3.06 0 0 .97-.31 3.19 1.18a11.1 11.1 0 0 1 2.9-.39c.98 0 1.97.13 2.9.39 2.21-1.49 3.18-1.18 3.18-1.18.63 1.59.23 2.77.11 3.06.74.81 1.19 1.84 1.19 3.1 0 4.43-2.69 5.41-5.26 5.7.41.36.78 1.06.78 2.14 0 1.55-.01 2.8-.01 3.18 0 .31.21.68.8.56A11.52 11.52 0 0 0 23.5 12.02C23.5 5.74 18.27.5 12 .5Z" />
    </svg>
);

const IconDiscord = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M20.317 4.492A19.7 19.7 0 0 0 16.558 3.3a.07.07 0 0 0-.075.036c-.163.292-.345.673-.472.972a18.36 18.36 0 0 0-5.517 0 12.7 12.7 0 0 0-.48-.972.07.07 0 0 0-.075-.036A19.7 19.7 0 0 0 6.18 4.492a.06.06 0 0 0-.028.024C2.628 9.789 1.66 14.94 2.13 20.03a.08.08 0 0 0 .03.055 19.87 19.87 0 0 0 5.994 3.03.07.07 0 0 0 .077-.027 14.24 14.24 0 0 0 1.228-2 .07.07 0 0 0-.04-.098 13.09 13.09 0 0 1-1.872-.893.07.07 0 0 1-.007-.117c.126-.094.252-.192.372-.291a.07.07 0 0 1 .073-.01c3.928 1.793 8.18 1.793 12.062 0a.07.07 0 0 1 .075.009c.12.099.246.198.373.292a.07.07 0 0 1-.006.117 12.29 12.29 0 0 1-1.873.892.07.07 0 0 0-.04.099c.36.699.772 1.363 1.226 2a.07.07 0 0 0 .078.027 19.8 19.8 0 0 0 6.002-3.03.08.08 0 0 0 .03-.055c.5-5.878-.838-10.983-3.548-15.514a.06.06 0 0 0-.028-.024ZM8.02 16.885c-1.182 0-2.157-1.086-2.157-2.42s.957-2.42 2.157-2.42c1.21 0 2.176 1.096 2.157 2.42 0 1.334-.958 2.42-2.157 2.42Zm7.976 0c-1.183 0-2.157-1.086-2.157-2.42s.957-2.42 2.157-2.42c1.21 0 2.175 1.096 2.157 2.42 0 1.334-.947 2.42-2.157 2.42Z" />
    </svg>
);

const IconTelegram = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M21.86 4.14a1.5 1.5 0 0 0-1.55-.24L2.9 10.86c-1.13.44-1.12 1.07-.2 1.36l4.53 1.41 10.5-6.62c.5-.3.95-.14.58.19l-8.5 7.68-.33 4.68c.44 0 .64-.2.88-.44l2.11-2.05 4.4 3.25c.81.45 1.4.22 1.6-.75l2.9-13.66c.3-1.19-.44-1.73-1.5-1.37Z" />
    </svg>
);

const IconTikTok = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.14V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.87a8.16 8.16 0 0 0 4.77 1.52V6.94a4.85 4.85 0 0 1-1.84-.25Z" />
    </svg>
);

const IconWhatsApp = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M12.04 2C6.52 2 2.03 6.48 2.03 12c0 1.76.46 3.48 1.33 5L2 22l5.12-1.34A9.95 9.95 0 0 0 12.03 22h.01c5.52 0 10.01-4.48 10.01-10S17.56 2 12.04 2Zm5.84 14.12c-.25.71-1.47 1.36-2.03 1.45-.52.08-1.18.12-1.9-.12-.44-.14-1-.33-1.72-.64-3.02-1.3-4.99-4.34-5.14-4.54-.15-.2-1.23-1.64-1.23-3.13 0-1.49.78-2.22 1.06-2.52.28-.3.61-.37.81-.37h.59c.19 0 .44-.07.69.53.25.6.85 2.07.92 2.22.08.15.13.33.03.53-.1.2-.15.33-.3.51-.15.18-.32.4-.46.54-.15.15-.3.31-.13.61.18.3.79 1.3 1.69 2.1 1.16 1.03 2.14 1.35 2.44 1.5.3.15.48.13.66-.08.18-.2.76-.89.96-1.19.2-.3.41-.25.69-.15.28.1 1.78.84 2.08.99.3.15.51.23.58.36.08.13.08.73-.17 1.44Z" />
    </svg>
);

const ITEMS = [
    { key: "x", label: "X", Icon: IconX },
    { key: "github", label: "GitHub", Icon: IconGitHub },
    { key: "discord", label: "Discord", Icon: IconDiscord },
    { key: "telegram", label: "Telegram", Icon: IconTelegram },
    { key: "tiktok", label: "TikTok", Icon: IconTikTok },
    { key: "whatsapp", label: "WhatsApp", Icon: IconWhatsApp },
];

/**
 * SocialLinks — bottom-right footer social row.
 * If a URL is empty, renders a disabled visual placeholder (no href, not clickable).
 * When URLs are populated in /src/config/socialLinks.js the icons become live.
 */
export const SocialLinks = ({ align = "end", hideHeading = false }) => {
    const { t } = useTranslation();
    const alignClass = align === "start" ? "md:items-start" : "md:items-end";

    return (
        <div
            data-testid="footer-social"
            className={`flex flex-col items-start ${alignClass} gap-3`}
        >
            {!hideHeading && (
                <div className="eyebrow text-white/50">{t("landing.footer.community")}</div>
            )}
            <ul
                className={`flex flex-wrap gap-2.5 ${align === "end" ? "md:justify-end" : ""}`}
            >
                {ITEMS.map(({ key, label, Icon }) => {
                    const url = socialLinks[key];
                    const enabled = typeof url === "string" && url.trim().length > 0;
                    const shared =
                        "group relative inline-flex items-center justify-center w-[44px] h-[44px] md:w-[52px] md:h-[52px] border border-white/[0.1] bg-white/[0.02] transition-all duration-300";

                    if (!enabled) {
                        return (
                            <li key={key}>
                                <span
                                    data-testid={`social-${key}-disabled`}
                                    aria-label={`${label} (link not yet available)`}
                                    aria-disabled="true"
                                    className={`${shared} opacity-30 cursor-not-allowed text-white/60`}
                                >
                                    <Icon className="w-[22px] h-[22px] md:w-[26px] md:h-[26px]" />
                                </span>
                            </li>
                        );
                    }

                    return (
                        <li key={key}>
                            <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={label}
                                data-testid={`social-${key}`}
                                className={`${shared} text-white/70 hover:text-cyan hover:border-cyan/60 hover:bg-cyan/[0.06] hover:-translate-y-0.5 hover:shadow-[0_0_20px_-4px_rgba(0,229,255,0.55)]`}
                            >
                                <Icon className="w-[22px] h-[22px] md:w-[26px] md:h-[26px]" />
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SocialLinks;
